import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const postHelpRequest = async (payload) => {
  const { data } = await SigliveServiceSSE({ method: 'POST', url: `/productivity-host/asking-help`, data: payload });

  return data;
};

export default postHelpRequest;
